export default __webpack_public_path__ + "static/media/pinterest_kod.579bb5f3.webp";